module.exports = __webpack_public_path__ + "static/media/Landscape-Gozo-Sunset.7c3e2e15.jpg";